import { Id } from '@typings/common';
import { NoodleProductTypes } from '@typings/graphql-models';

type Product = {
  id: Id;
  productTypes: {
    noodleProductType?: NoodleProductTypes | null;
  }[]
};

const findProductByType = (type: NoodleProductTypes) => (product: Product): boolean => (
  product.productTypes.map(t => t.noodleProductType).includes(type)
);

const getPrimaryProductId = (purchasedProducts: Product[]): Id | null => purchasedProducts.find(findProductByType(NoodleProductTypes.Lite))?.id
  || purchasedProducts.find(findProductByType(NoodleProductTypes.Subscription))?.id
  || purchasedProducts.find(findProductByType(NoodleProductTypes.Response))?.id
  || (purchasedProducts.length > 0 && purchasedProducts[0]?.id)
  || null;

export default getPrimaryProductId;